<div class="cards-container">
  <ng-content select="[header]"></ng-content>

  <ng-content select="[content]"></ng-content>
</div>
